import Api from "./Api";

export default class AgentApi extends Api {
  constructor() {
    super("/agent");
  }
}